import styled from "styled-components";

import { getBorderRadius, getSemanticColor, getSpacing } from "@braze/beacon-styling";

import { widthTransitionDurationMs } from "../AgenticChatInterface/AgenticChatInterface.style";
import { defaultHeightPx } from "./constants";

export const heightTransitionDurationMs = 400;

export const StyledDiffHighlightEditor = styled.div`
  width: 100%;
  min-width: 0;
  /* Placeholder until Monaco loads and the component sizes the pane to its content. */
  height: ${defaultHeightPx}px;
  transition:
    min-height ${heightTransitionDurationMs}ms cubic-bezier(0.4, 0, 0.2, 1),
    height ${heightTransitionDurationMs}ms cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${widthTransitionDurationMs}ms;
  overflow: hidden;
  border-radius: ${getBorderRadius("tiny")};

  .monaco-editor {
    /* Vertical padding comes from the editor's own padding option so it counts toward
       getContentHeight(); only the horizontal padding lives here. */
    padding: 0 ${getSpacing("xs")};
    --vscode-editor-background: ${getSemanticColor("neutral-background-weak")};
    --vscode-editorGutter-background: transparent;
    --vscode-focusBorder: transparent;
    --vscode-editorWidget-border: transparent;
  }

  .monaco-editor .scroll-decoration {
    display: none;
  }

  /* Inline removed changes highlight */
  .monaco-editor .diff-removed-inline {
    background-color: ${getSemanticColor("danger-background-medium")};
  }

  /* Inline added changes highlight */
  .monaco-editor .diff-added-inline {
    background-color: ${getSemanticColor("success-background-medium")};
  }

  /* Scrollbar decorations */
  .monaco-editor .decorationsOverviewRuler {
    display: none !important; /* overrides inline styles */
  }

  /* Line numbers styles */
  .monaco-editor .margin-view-overlays .line-numbers {
    text-align: left;
    color: ${getSemanticColor("neutral-text-support")};
  }

  /* Indent decorations */
  .monaco-editor .core-guide.core-guide-indent {
    display: none;
  }

  /* Current line decorations */
  .monaco-editor .view-overlays .current-line-exact {
    border: none;
  }
`;
